<template>
  <div ref="certificate" class="certificate">
    <img src="../assets/images/myAccount/SA Certificate (Blank)_page-0001 (2).jpg" class="background-image"
      alt="Certificate Background" />
    <div class="content">
      <div class="header">
        <img src="../assets/images/logo/logo1.png" alt="StockAnts" style="width: 250px;" />
      </div>
      <div class="titles">Certificate of Performance</div>
      <div class="line"
        style="font-family: 'inter', serif; text-align: center; margin: 20px 0; font-size: 2vw; line-height: 1.2; position: relative;">
        <div class="highlight"></div>
        Proudly Honored to
      </div>

      <div class="name">{{ certificateData.user_name }}</div>
      <div class="achievement">
        For
        <span style="font-weight: bold;">{{ certificateData.equity_reco }} Recommendations</span>
        in <span style="font-weight: bold;">Equity</span> &
        <span style="font-weight: bold;">{{ certificateData.option_strategy }} Strategies</span>
        <br />
        in Options from
        <span style="font-weight: bold;">{{ formattedStartDate }}</span> to
        <span style="font-weight: bold;">{{ formattedEndDate }}</span>
      </div>
      <div class="name-container">
        <div class="signature-stamp-date">
          <div class="signature">
            <img src="../assets/images/myAccount/Signature.png" alt="Signature" />
            <br />
            <span style="font-weight: bold;">Pallavi Bid</span> <br />
            <span style="font-weight: lighter; font-size:15px; font-family: inter, serif;">Founder, StockAnts</span>
          </div>
          <div class="stamp">
            <img src="../assets/images/myAccount/Stamp.svg" alt="Stamp" />
            <br />
            <span></span><br />
            <span style="font-weight: lighter; font-size:15px; font-family: inter, serif;">Stamp</span>
          </div>
          <div class="signature">
            <img src="https://prod-api.stockants.com/Media/important_doc/signature.png" alt="Signature"
              style=" visibility: hidden;" />
            <br />
            <span style="font-weight: bold;">{{ formattedEndDate }}</span>
            <br />
            <span style="font-weight: lighter; font-size:15px; font-family: inter, serif;">Date</span>
          </div>
        </div>
      </div>
      <div class="footer">StockAnts is a marketplace for price estimates</div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import moment from "moment";

export default {
  name: "Certificate",

  data() {
    return {
      certificateData: {
        user_name: "",
        equity_reco: "",
        option_strategy: "",
        start_date: "",
        end_date: "",
      },
    };
  },
  computed: {
    formattedStartDate() {
      return this.certificateData.start_date
        ? moment(this.certificateData.start_date).format("D MMMM YYYY")
        : "";
    },
    formattedEndDate() {
      return this.certificateData.end_date
        ? moment(this.certificateData.end_date).format("D MMMM YYYY")
        : "";
    },
  },
  methods: {
    getCertificateData() {
      serverAddr
        .get("/stockants_pro/get-transaction-history/")
        .then((response) => {
          const transaction = response.data.data.find(
            (trx) => trx.plan_name === "Publisher"
          );
          if (
            transaction &&
            transaction.publisher_certificate_data.length > 0
          ) {
            this.certificateData = transaction.publisher_certificate_data[0];
            this.certificateData = {
              user_name: data.user_name,
              equity_reco: data.equity_reco,
              option_strategy: data.option_strategy,
              start_date: moment(data.start_date).format("D MMMM YYYY"),
              end_date: moment(data.end_date).format("D MMMM YYYY"),
            };
          }
        })
        .catch((error) => {
          console.error("Error fetching transaction data:", error);
        });
    },
  },

  mounted() {
    this.getCertificateData();
  },
};
</script>
<style lang="scss">
.certificate {
  position: relative;
  width: 70%;
  margin: 50px auto;
  /* border: 0.5px solid #000; */


  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }

  .content {
    position: relative;
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    padding: 50px 20px;
    box-sizing: border-box;
    text-align: center;
    color: #000;
  }

  .titles {
    font-family: "Bellefair", serif;
    text-align: center;
    margin-top: 20px;
    font-size: 3vw;
    font-weight: lighter;
    line-height: 1.2;
  }

  .line {
    font-family: "inter", serif;
    text-align: center;
    margin: 20px 0;
    font-size: 2vw;
    line-height: 1.2;
  }

  .name-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;
  }

  .name {
    font-family: "inter", serif;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    line-height: 1.2;
  }

  .achievement {
    font-family: "inter", serif;
    margin-bottom: 20px;
    margin-top: 20px;
    font-size: 1.5vw;
    text-align: center;
    line-height: 1.5;
  }

  .signature-stamp-date {
    display: flex;
    align-items: center;
  }

  .signature,
  .stamp,
  .date {
    text-align: center;
    padding: 20px;
    width: 220px;
  }

  .signature img,
  .stamp img,
  .date img {
    width: 40%;
    height: auto;
    margin: 20px auto;
  }

  .footer {
    margin-top: 10px;
    font-size: 1.5vw;
    color: #df6052;
    text-align: center;
  }

  .line {
    font-family: "inter", serif;
    text-align: center;
    margin: 20px 0;
    font-size: 2vw;
    line-height: 1.2;
    position: relative;
  }

  .line::before,
  .line::after {
    content: "";
    position: absolute;
    top: 50%;
    width: calc(50% - 180px);
    height: 1px;
    background-color: #000;
  }

  .line::before {
    left: 0;
    transform: translateY(-50%);
  }

  .line::after {
    right: 0;
    transform: translateY(-50%);
  }

  .highlight {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 1px;
    /* background-color: #fff;  */
  }

  .line {
    position: relative;
  }

  @media (max-width: 767px) {
      width: 95%;

    .content {
      padding: 30px 10px;
    }

    .titles {
      font-size: 8vw;
    }

    .line::before,
    .line::after {
      width: 30%;
    }

    .name {
      font-size: 6vw;
    }

    .achievement {
      font-size: 4vw;
    }

    .signature,
    .stamp,
    .date {
      width: 100%;
    }

    .signature img,
    .stamp img {
      width: 80%;
    }
  }
}
</style>
